// extracted by mini-css-extract-plugin
export default {"container":"dZs5e3","search":"krCqqh","large":"mtJpOF","side-by-side-mobile":"PZIDK7","sideBySideMobile":"PZIDK7","userName":"mJ89ha","profileLink":"taLqKM"};